<template>
  <div class="container-fluid bg-white vh-100 p-0">
    <ClientLogo v-if="this.$route.name != 'behalf_application'" />
    <BreadCrumb label="Academic Post 92 Check Verification" />

    <div class="d-flex justify-content-center align-items-center min-vh-50">
      <div class="col-11 col-sm-10 col-md-8 col-lg-6 col-xl-5 p-3">
        <AcademicCheckForm ref="academicForm" @submit="submit_academic_check" />
        <div class="text-center mb-3 mt-4">
          <button
            class="btn btn-sm bg-green secondary-text-dark rounded-small fw-bold text-xs shadow-sm"
            @click.prevent="$refs.academicForm.submitForm()"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb/BreadCrumb.vue";
import ClientLogo from "@/components/ClientLogo/ClientLogo.vue";
import AcademicCheckForm from "../../background_screening/academic_check/AcademicCheckForm.vue";
import { API_BASE_URL } from "@/config";
import { MAIN_CONTROLLER } from "@/utils/main_controller.js";


export default {
  name: "AcademicPost92CheckVerification",
  mixins: [MAIN_CONTROLLER],
  components: {
    BreadCrumb,
    ClientLogo,
    AcademicCheckForm,
  },
  methods: {
    submit_academic_check(formData) {
      const TOKEN = localStorage.getItem("token");
      const ACADEMIC_CHECK_API = `${API_BASE_URL}/verify_api/background_screening/academic_check/create-academic-check/`;

      $.ajax({
        url: ACADEMIC_CHECK_API,
        method: "POST",
        contentType: "application/json",
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        data: JSON.stringify(formData),
        success: (response) => {
          var status_message = response.status;
          if (status_message == "success") {
            this.completeService();
          } else {
            Swal.fire({
              icon: "error",
              text: "Our service is currently unavailable. Please try again later",
            });
          }
        },
        error: (error) => {
          let error_message = "Something went wrong!";

          if (error.responseJSON && error.responseJSON.message) {
            error_message = error.responseJSON.message;
            $(".error-message").text(error_message).removeClass("d-none");
            setTimeout(() => {
              $(".error-message").text("").addClass("d-none");
            }, 3000);
          } else {
            Swal.fire({
              icon: "error",
              text: "Our service is currently unavailable. Please try again later",
            });
          }
        },
      });
    },
  },
};
</script>
